import React from "react";
import { Colors } from "@utils";
import { Button } from "@components/atoms";

import logoImage from "@assets/images/logo.png";
import reportImage from "@assets/images/image_report.png";
import { useNavigate } from "react-router-dom";

const IntroPage: React.FC = () => {
  const navigate = useNavigate();

  const gotoTutorial = React.useCallback(() => {
    navigate("/tutorial/1");
  }, [navigate]);

  return (
    <div className="flex flex-col p-[22px] min-h-full">
      <div className="text-center">
        <img
          src={logoImage}
          alt=""
          className="block w-[207px] h-[40px] mx-auto"
        />
      </div>
      <div className="p-[23px] mt-[52px]">
        <div
          className="text-[28px]/[33px] font-[600] whitespace-pre-wrap mb-[16px]"
          style={{ color: Colors.gray1 }}
        >
          나의 건강성적은{"\n"}몇 점일까요?
        </div>
        <div
          className="text-[18px]/[21px] font-[600] whitespace-pre-wrap"
          style={{ color: Colors.gray1 }}
        >
          10만 원 상당의 건강검진 분석이{"\n"}
          <span style={{ fontWeight: "bold", color: Colors.totallyBlack }}>
            오늘만 무료
          </span>
          예요
        </div>
      </div>
      <div className="flex grow items-center justify-center my-[20px]">
        <img src={reportImage} alt="" className="w-[160px] h-[170px]" />
      </div>
      <Button
        bgColor={Colors.primaryGreen}
        color={Colors.white}
        onClick={gotoTutorial}
      >
        지금 나의 건강성적 알아보기
      </Button>
      <div
        className="text-[13px]/[15px] font-[600] whitespace-pre-wrap mt-[14px] mb-[40px] text-center"
        style={{ color: Colors.gray1 }}
      >
        <span style={{ fontWeight: "bold", color: Colors.totallyBlack }}>
          서울대학교 보건환경 연구소
        </span>
        와 렉스소프트에서 개발한{"\n"}
        AI 건강 분석 서비스입니다.
      </div>
    </div>
  );
};

export default IntroPage;
